const CAR_BRAND_SESSION = 'CAR_BRAND_SESSION_131';

export const setBrandSession = (data) => {
    try {
        sessionStorage.setItem(CAR_BRAND_SESSION, JSON.stringify(data));
    } catch (err) {
        sessionStorage.setItem(CAR_BRAND_SESSION, JSON.stringify([]));
    }
};

export const clearBrandSession = () => {
    try {
        sessionStorage.removeItem(CAR_BRAND_SESSION);
    } catch (err) {
        // do nothing
    }
};

export const getBrandSession = () => {
    try {
        return JSON.parse(sessionStorage.getItem(CAR_BRAND_SESSION) || '[]');
    } catch (err) {
        return [];
    }
};



// WEBPACK FOOTER //
// ./src/utils/session.js